export default "__VITE_ASSET__DYc0kz9A__"